/** Routes = screens; one file per artboard (design/*.dc.html). The URL vocabulary is the visible one (reporte, comprobante). */
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth, type AuthState } from './state/auth.ts';
import Acceso from './screens/Acceso.tsx';
import Viajes from './screens/Viajes.tsx';
import NuevoViaje from './screens/NuevoViaje.tsx';
import Viaje from './screens/Viaje.tsx';
import Captura from './screens/Captura.tsx';
import Confirmar from './screens/Confirmar.tsx';
import Comprobante from './screens/Comprobante.tsx';
import Atencion from './screens/Atencion.tsx';
import CodigoFiscal from './screens/CodigoFiscal.tsx';
import Compartir from './screens/Compartir.tsx';
import Operador from './screens/Operador.tsx';
import { Loading } from './theme/ui.tsx';

export type Session = Pick<AuthState, 'displayName' | 'email' | 'isOperator'>;

export default function App() {
  const auth = useAuth();
  const loc = useLocation();
  if (auth.loading) return <div className="screen"><Loading /></div>;
  if (!auth.principal) return loc.pathname === '/acceso' ? <Acceso /> : <Navigate to="/acceso" replace state={{ from: loc.pathname + loc.search }} />;
  const s: Session = { displayName: auth.displayName, email: auth.email, isOperator: auth.isOperator };
  return (
    <Routes>
      <Route path="/acceso" element={<Navigate to="/" replace />} />
      <Route path="/" element={<Viajes session={s} />} />
      <Route path="/nuevo" element={<><Viajes session={s} /><NuevoViaje /></>} />
      <Route path="/reporte/:tripId" element={<Viaje session={s} />} />
      <Route path="/reporte/:tripId/nuevo" element={<><Viaje session={s} /><NuevoViaje /></>} />
      <Route path="/reporte/:tripId/captura" element={<Captura />} />
      <Route path="/revisar" element={<Confirmar session={s} />} />
      <Route path="/comprobante/:id" element={<Comprobante />} />
      <Route path="/comprobante/:id/retomar" element={<Captura />} />
      <Route path="/atencion" element={<Atencion />} />
      <Route path="/datos-fiscales" element={<CodigoFiscal />} />
      <Route path="/compartir" element={<Compartir />} />
      {/* screen 11 · Operador: one more screen for the factura-admin role (the operator is an employee too); the SWA config gates /operador/* by role as well */}
      <Route path="/operador" element={s.isOperator ? <Operador session={s} /> : <Navigate to="/" replace />} />
      <Route path="/operador/:queueItemId" element={s.isOperator ? <Operador session={s} /> : <Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
